import { NAO_CONFORMIDADES_CLIENTES_EXTENSION, generalObjectBuilder, genericDelete, genericPost, genericUpdate } from "../../../services/api.service";
import TableView from "../../Common/TableView";
import { NaoConformidadesClientesConfig } from "./NaoConformidadesClientes.config";



export function NaoConformidadesCliente() {



    return (<div>
        <TableView
            title={"Não conformidades Clientes"}

            postEntity={genericPost(NAO_CONFORMIDADES_CLIENTES_EXTENSION)}
            editEntity={genericUpdate(NAO_CONFORMIDADES_CLIENTES_EXTENSION)}
            deleteEntity={genericDelete(NAO_CONFORMIDADES_CLIENTES_EXTENSION)}
            addButtonText={"Nova Não conformidade Cliente"}
            tableConfigs={NaoConformidadesClientesConfig}
            dataBuildFunction={generalObjectBuilder(NaoConformidadesClientesConfig)}
            entityName={"Não conformidade Cliente"}
            idProp={"code"}
            reroute={true}
            configMapKey={"nao-conformidades-clientes"}
        />
    </div>)



}